const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  menus: state => state.permission.menus,
  routers: state => state.permission.routers,
  dashname: state => state.dashboard.dashname,
  layout: state => state.dashboard.layout,
  datas: state => state.dashboard.datas,
  id: state => state.user.productionLineId,
  editorId: state => state.dashboard.editorId
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js